export const rules = {
  name: [
    { required: true, message: "请输入设备名称", trigger: "blur" },
  ],
  data_type: [
    { required: true, message: "请选择", trigger: "change" },
  ],
  slave_id: [
    { required: true, message: "请输入", trigger: "change" },
  ],
  address: [
    { required: true, message: "请输入", trigger: "change" },
  ],
  function_code: [
    { required: true, message: "请输入", trigger: "change" },
  ]
}





